import {Collapsible as CollapsiblePrimitive} from 'radix-ui';

const Collapsible = CollapsiblePrimitive.Root;

const {CollapsibleTrigger, CollapsibleContent} = CollapsiblePrimitive;

export {Collapsible, CollapsibleTrigger, CollapsibleContent};
